var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"abox"},[_c('img',{staticClass:"img",attrs:{"src":_vm.imgServer+'/family_citymanager.png'}}),_c('img',{staticClass:"logo",attrs:{"src":_vm.imgServer+'/logo2.png'}})])])}
var staticRenderFns = []

export { render, staticRenderFns }